<template>
  <div
    :id="idFormblock"
    :class="['callback-block', 'callback-block--' + theme]"
  >
    <content-wrapper-block class="callback-block__row">
      <div class="callback-block__left">
        <div class="callback-block__title">
          {{ title }}
        </div>
        <div class="callback-block__subtitle">
          {{ subtitle }}
        </div>
        <form
          :id="id"
          ref="callback-form"
          method="POST"
          class="callback-block__form callback-form"
          @submit.prevent="submit"
        >
          <div class="callback-form__row">
            <div class="callback-form__col col-3">
              <ui-input
                :id="id + '-name'"
                ref="form-name"
                v-model="name"
                hint="Введите корректные данные"
                :dark="theme === 'black' ? true : false"
                placeholder-value="Имя *"
                required
              />
            </div>
            <div class="callback-form__col col-3">
              <ui-input
                :id="id + '-phone'"
                ref="form-phone"
                v-model="phone"
                v-mask="'+7 (###) ###-##-##'"
                type="tel"
                :dark="theme === 'black' ? true : false"
                hint="Введите корректный номер телефона"
                placeholder-value="телефон *"
                required
              />
              <div v-if="!isPhoneValid" class="form-phone_valid">
                Введите корректный номер телефона
              </div>
            </div>
            <div class="callback-form__col col-3">
              <ui-input
                :id="id + '-email'"
                ref="form-email"
                v-model="email"
                type="email"
                hint="Введите корректный email"
                :dark="theme === 'black' ? true : false"
                :error="!isEmailValid"
                placeholder-value="email"
              />
              <div v-if="!isEmailValid" class="form-email_valid">
                Введите корректный email
              </div>
            </div>
            <input v-model="hidden" name="ch" />
            <div ref="captcha" class="callback-form__captcha" />
            <div class="callback-form__col">
              <ui-button
                type="submit"
                :outline="theme === 'black' ? false : true"
                :loading="loading"
                @click="submitForm"
              >
                Отправить
              </ui-button>
            </div>
          </div>
          <div class="callback-form__email-info">Подпишитесь, чтобы не пропустить актуальные предложения и акции!</div>
          <div v-if="enableAgreement" class="callback-form__row agreement">
            <div class="callback-form__col">
              <ui-input
                :id="id + '-agreement'"
                ref="form-agreement"
                v-model="checkbox"
                class="row"
                type="checkbox"
                :dark="theme === 'black' ? true : false"
                required
              >
                <template #label>
                  <span
                    >Ознакомлен(а) с
                    <a
                      href="/Политика_обработки_персональных_данных.pdf"
                      target="_blank"
                      >Политикой обработки персональных данных</a
                    >
                    и даю
                    <router-link
                      :to="{ name: 'DataConsentPage' }"
                      target="_blank"
                      >согласие</router-link
                    >
                    на их обработку.
                  </span>
                </template>
              </ui-input>
            </div>
            <div class="callback-form__col">
              <ui-input
                :id="id + '-promotion'"
                ref="form-agreement-promotion"
                v-model="checkboxPromotion"
                class="row"
                type="checkbox"
                :dark="theme === 'black' ? true : false"
              >
                <template #label>
                  <span
                    >Я даю согласие на получение
                    <router-link
                      :to="{ name: 'PromotionPage' }"
                      target="_blank"
                      >рекламных рассылок</router-link
                    >.
                  </span>
                </template>
              </ui-input>
            </div>
          </div>
        </form>
      </div>
      <!-- <div class="callback-block__right" :style="backgroundStyle" /> -->
    </content-wrapper-block>
  </div>
</template>

<script>
import { helpers } from "@osnova-adv/ms3-blocks";
import ContentWrapperBlock from "@/components/blocks/ContentWrapperBlock";
import UiInput from "@/components/ui/UIInput";
import UiButton from "@/components/ui/UIButton";
import { subscribeInFooter } from "@/mindbox"

export default {
  name: "CallbackBlock",
  components: {
    ContentWrapperBlock,
    UiInput,
    UiButton,
  },
  props: {
    idFormblock: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "ui-input",
    },
    title: {
      type: String,
      default: "Остались вопросы?",
    },
    subtitle: {
      type: String,
      default:
        "Оставьте свои контакты, и наш менеджер подробно проконсультирует вас",
    },
    theme: {
      type: String,
      default: "white",
    },
    image: {
      type: String,
      default: "",
    },
    enableAgreement: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    name: "",
    phone: "",
    email: "",
    hidden: "",
    checkbox: false,
    checkboxPromotion: false,
    captcha: null,
    loading: false,
  }),
  computed: {
    backgroundStyle() {
      return {
        background: `#FFF url(${this.image}) no-repeat 50% 50%`,
        backgroundSize: "cover",
        height: "333px",
      };
    },
    isPhoneValid() {
      return this.phone.length >= 18 || this.phone.length < 1;
    },
    isEmailValid() {
      const value = this.email.trim();
      return !value || /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value);
    },
  },
  // async mounted() {
  //   this.captcha = new helpers.Captcha();
  //   await this.captcha.load();
  //   this.captcha.render({
  //     el: this.$refs.captcha,
  //     params: { sitekey: this.yandexCaptchaKey },
  //   });
  //   this.captcha.on("challenge-hidden", this.hideLoader);
  //   this.captcha.on("success", this.send);
  // },
  methods: {
    send() {
      try {
        subscribeInFooter({ phone: this.phone, email: this.email, isSubscribed: this.checkboxPromotion });
      } catch (e) { 
        console.error("[mindbox]", e); 
      }
      window.Comagic.addOfflineRequest(
        {
          name: "Имя: " + this.name + " | " + "Форма: " + this.title,
          phone: this.phone,
          ...(this.email?.trim() ? { email: this.email.trim() } : {}),
          message:
            "Описание: " +
            this.title +
            " | " +
            "URL: " +
            document.URL +
            " | " +
            "ID: " +
            this.idFormblock,
        },
        ({ response }) => {
          const result = JSON.parse(response);
          if (result.success) {
            window.popupWithChats.showResponse({ success: true });
            dataLayer.push({
              event: "form-send",
              "event-category": "proposition",
              "event-action": "send",
            });
          } else {
            window.popupWithChats.showResponse();
          }
          this.reset();
        }
      );
    },
    submitForm() {
      this.$refs["form-name"].$refs.VueInputUi.classList.add("attempt");
      this.$refs["form-phone"].$refs.VueInputUi.classList.add("attempt");
      this.$refs["form-agreement"]?.$refs.VueInputUi.classList.add("attempt");
    },
    submit() {
      if (!this.$captchaVerified) {
        console.log('Captcha not verified — popup blocked');
        return; 
      }
      if (this.hidden || this.phone.length !== 18 || !this.name.trim() || !this.isEmailValid) {
        return;
      }
      this.$refs["form-name"].$refs.VueInputUi.classList.remove("attempt");
      this.$refs["form-phone"].$refs.VueInputUi.classList.remove("attempt");
      // if (!this.captcha.loaded) {
      //   window.popupWithChats.showResponse();
      //   return this.clear();
      // }
      this.showLoader();
      // this.captcha.execute();
      this.send();
    },
    reset() {
      this.hideLoader();
      this.clear();
      this.captcha.reset();
    },
    clear() {
      this.name = "";
      this.phone = "";
      this.email = "";
      this.checkboxPromotion = false;
      this.checkbox = false;
    },
    showLoader() {
      this.loading = true;
    },
    hideLoader() {
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.callback-block {
  padding: 0;

  @media screen and (min-width: $screen-sm) {
    padding: 70px 0;
  }

  &--white {
    background: #2e2a2b;

    .callback-block__left {
      background: #fff;
    }
  }

  &--black {
    background: rgba(0, 0, 0, 0.95);

    .callback-block__left {
      background: #000;
      border: 0;
      color: #ffffff;
      padding-top: 30px;

      @media screen and (min-width: $screen-sm) {
        border: 1px solid rgba(255, 255, 255, 0.75);
        padding-top: 0;
      }
    }
  }

  &__title {
    font-family: Bebas Neue, serif;
    font-style: normal;
    font-weight: normal;
    margin-bottom: 15px;
    letter-spacing: 0.05em;

    margin-top: 0;
    font-size: 24px;
    line-height: 105%;

    @media screen and (min-width: $screen-sm) {
      margin-top: 30px;
      font-size: 36px;
      line-height: 130%;
    }
  }
  &__subtitle {
    font-size: 14px;
    letter-spacing: 0.2em;
    text-transform: uppercase;
  }
  &__col {
    display: none;
  }
  &__row {
    display: flex;
    align-items: center;
    padding: 0;

    .row {
      a {
        color: rgba(24, 24, 27, 0.5);
        &:hover {
          text-decoration: none;
        }
      }
    }

    @media screen and (min-width: $screen-sm) {
      padding: 0 15px;
    }
  }
  &__left {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 15px;

    @media screen and (min-width: $screen-sm) {
      padding: 40px;
    }
    @media screen and (min-width: $screen-md) {
      padding: 0 25px 0 25px;
    }
    @media screen and (min-width: $screen-lg) {
      padding: 0 75px 0 45px;
    }
  }
  &__right {
    width: 370px;
    display: none;

    @media screen and (min-width: $screen-md) {
      display: inline;
    }
  }
}
.callback-form {
  padding: 27px 0;

  @media screen and (min-width: $screen-mini) {
    padding: 51px 0;
  }

  &__email-info {
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0.175em;
    text-transform: uppercase;
  }

  &__row {
    display: flex;
    gap: 20px;
    padding-bottom: 22px;
    flex-direction: column;
    @media screen and (min-width: $screen-md) {
      flex-direction: row;
      gap: 37px;
    }

    &:last-child {
      padding-bottom: 0;
    }

    &.agreement {
      gap: 0;
      flex-direction: column;
    }
  }
  .col-3 {
    position: relative;
    width: 100%;
    margin-right: 20px;
    margin-bottom: 10px;

    @media screen and (min-width: $screen-sm) {
      width: 100%;
      margin-right: 0;
      margin-bottom: 0;
    }
    @media screen and (min-width: $screen-md) {
      width: auto;
    }

    &:last-child {
      margin-right: 0;
    }
  }
  .form-phone_valid,
  .form-email_valid {
    position: absolute;
    bottom: -7px;
    font-family: Rubik;
    font-size: 11px;
    text-transform: none;
    color: #ed0000;
  }

  .ui-button {
    width: 100%;
  }

  &__captcha {
    display: none;
  }

  input {
    &[name="ch"] {
      display: none;
      visibility: hidden;
    }
  }
}
</style>
